// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('customerinvoice', {
        url: '/customerinvoice',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/customerinvoice/customerinvoice.tpl.html',
        controller: 'MainCustomerInvoiceController as vm'
    });
}

// @ngInject
function MainCustomerInvoiceController() {
    var vm = this;
}

angular
    .module('main.customerinvoice', ['customerinvoices.api','customerinvoice.customerinvoicesearch', 'customerinvoice.customerinvoicerowsearch'])
    .config(stateConfig)
    .controller('MainCustomerInvoiceController', MainCustomerInvoiceController);
